import React from "react";

import { TaskSubmissionsPage } from "@harrow-education/ui-components";

const TaskSubmissions = (props) => {
  return <TaskSubmissionsPage {...props} />;
};

export default TaskSubmissions;
